<a
  *ngIf="forwardParams() as qp; else backOrPlain"
  class="clickable-description"
  [routerLink]="FILING_FORM_ROUTE"
  [queryParams]="qp"
  queryParamsHandling="merge"
  [pTooltip]="tooltipText()"
  [escape]="true"
  tooltipStyleClass="field-link-tooltip"
  tooltipPosition="top"
  [innerHTML]="control.label | negativeLabel"
></a>

<ng-template #backOrPlain>
  <a
    *ngIf="backLinks().length > 0; else plainLabel"
    class="clickable-description"
    [routerLink]="shouldUseChooser() ? null : FILING_FORM_ROUTE"
    [queryParams]="shouldUseChooser() ? null : backParams()"
    queryParamsHandling="merge"
    (click)="onBackClick()"
    [pTooltip]="backTooltipText()"
    [escape]="true"
    tooltipStyleClass="field-link-tooltip"
    tooltipPosition="top"
    [innerHTML]="control.label | negativeLabel"
  ></a>
  <ng-template #plainLabel>
    <span [innerHTML]="control.label | negativeLabel"></span>
  </ng-template>
</ng-template>

<app-field-link-back-chooser
  *ngIf="chooserVisible"
  [options]="backLinks()"
  [visible]="chooserVisible"
  (visibleChange)="chooserVisible = $event"
/>
